import script from "./TermsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TermsModal.vue?vue&type=script&setup=true&lang=js"

import "./TermsModal.vue?vue&type=style&index=0&id=672ba6e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-672ba6e4"]])

export default __exports__